import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../config/languages'

/** Bump when `public/locales/*.json` changes to bust CDN/browser cache. */
const LOCALE_VERSION = '24'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `/locales/{{lng}}.json?v=${LOCALE_VERSION}`
    },
    detection: {
      order: ['path', 'navigator', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
      convertDetectedLanguage: (lng) => {
        // Map both pt-PT and pt-BR to our 'pt' locale for Brazilian Portuguese
        if (lng.startsWith('pt')) return 'pt'
        return lng
      }
    }
  })
  .then(() => {
    if (!(SUPPORTED_LANGUAGES as string[]).includes(i18n.language)) {
      i18n.changeLanguage(DEFAULT_LANGUAGE)
    }
  })

export default i18n
